<p-panel class="collapsible-panel medsurf-collapsible-panel"
  [toggleable]="false"
  [collapsed]="isMinimized"
  (collapsedChange)="toggleIsMinimized()">
  <ng-template pTemplate="header">
    @if (!isMinimized) {
      <div class="flex flex-grow-1 flex-shrink-1 p-panel-title">
        {{ titleText | translate }}
      </div>
    }
  </ng-template>
  <ng-template pTemplate="icons">
    <div class="flex flex-row-reverse column-gap-2 min-w-4rem overflow-hidden ml-2">
      @if (menuItems?.length) {
        <medsurf-design-input-menu
          [formField]="false"
          [name]="id + '_menu'"
          [tooltipLabel]="tooltipLabel"
          [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.DEFAULT"
          [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
          [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
          [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
        [loadMenuItems]="addCollapseMenuItem"></medsurf-design-input-menu>
      }
  
      @if (!menuItems?.length) {
        <button medsurf-design-input-button
          [id]="'collapsible_panel_button'"
          [title]="getMinimizedLabel() | translate"
          [iconClass]="getMinimizedClass()"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
        (click)="toggleIsMinimized()"></button>
      }

      @if (!isMinimized) {
        <ng-content select="panel-header-extra"></ng-content>
      }
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    @if (!isMinimized) {
      <ng-content></ng-content>
    }
  </ng-template>
</p-panel>